module.exports = "<settings-editor></settings-editor> ";


//////////////////
// WEBPACK FOOTER
// ./app/settings/site/settings-general.html
// module id = 875
// module chunks = 0